import SinglePromotion from "../promotions/SinglePromotion"

import "./PastPromotions.css"

export interface IPromotionsCalendarProps {
  pastPromotions: any[]
  dietProducts: any[]
  psychologyProducts: any[]
}

const PromotionsCalendar = ({
  pastPromotions,
  dietProducts,
  psychologyProducts
}: IPromotionsCalendarProps) => {
  return (
    <section className="bf-past-promotions">
      <div className="bf-past-promotions-list">
        {pastPromotions.map((promotion, i) => (
          <SinglePromotion
            id={promotion.id}
            dietProducts={dietProducts}
            psychologyProducts={psychologyProducts}
            date={promotion.date}
            inCouple={promotion.inCouple}
            subtitle={promotion.subtitle}
            title={promotion.title}
            type={promotion.type}
            hasOptions={promotion.hasOptions}
            showSessionOptions={promotion.showSessionOptions}
            showSubscriptionOptions={promotion.showSubscriptionOptions}
            discount={promotion.discount}
            hasBackground={false}
            prominentPromotion={true}
          />
        ))}
      </div>
    </section>
  )
}

export default PromotionsCalendar
